/**
 * One CSV cell. A string that a spreadsheet would run as a formula is prefixed with
 * an apostrophe; numbers are left alone so a negative figure stays a number.
 */
export function csvCell(value) {
    if (value === null || value === undefined)
        return "";
    if (typeof value === "number")
        return String(value);
    const safe = /^[=+\-@\t\r]/.test(value) ? `'${value}` : value;
    return /[",\n\r]/.test(safe) ? `"${safe.replaceAll('"', '""')}"` : safe;
}
//# sourceMappingURL=csv.js.map